export default __webpack_public_path__ + "static/media/iceland.249caa9d.jpg";